import * as React from 'react';

import styles from './ProductCard.scss';
import { genPublicUrl } from 'libs/image';
import type { CatalogProductCard as CatalogProductCardType } from 'components/catalogs/libs/catalogApiClient';

type Props = {
  catalogCode: string;
  product: CatalogProductCardType;
};

const toCatalogProductPath = (catalogCode: string, catalogProductId: number): string =>
  `/catalogs/${encodeURIComponent(catalogCode)}/products/${encodeURIComponent(String(catalogProductId))}`;

export const ProductCard = ({ catalogCode, product }: Props): JSX.Element => (
  <a
    className={styles.card}
    href={toCatalogProductPath(catalogCode, product.catalogProductId)}
    aria-label={product.title}
  >
    <div className={styles.thumb}>
      {product.imageUrl ? (
        <img
          className={styles.thumbImage}
          src={genPublicUrl(product.imageUrl, 640)}
          alt=""
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div className={styles.thumbPlaceholder} />
      )}
    </div>
    <div className={styles.title}>{product.title}</div>
  </a>
);
